export default __webpack_public_path__ + "images/4485687f7242e3bdea519889c4320d1f.svg";